import React, {PureComponent} from "react";
import {Col, Row} from "reactstrap";
import PubSub from 'pubsub-js';
import Widget from '../../../components/Widget';
import {EjecutivoBanco} from "../objects/ejecutivo_banco";
import BarChart from "../charts/BarChart";
import {SectionalCountry} from "../../../components/CountrySectional/SectionalCountry";
import {CountrySectionalComparativeModel} from "../../../components/CountrySectional/model/CountrySectionalComparativeModel";

export class DetailSales extends PureComponent {
    state = {
        data : [],
        dataGlobal : [],
        compliance: [],
        totalCompliance: [],
        maxYear : this.props.maxYear,
        mes : this.props.mes,
        sectional : this.props.sectional
    }
    Total;

    componentDidMount() {
        PubSub.subscribe('reloadmaxYear', this.onmaxyaer.bind(this));
        PubSub.subscribe('reloadmes', this.onmes.bind(this));
        PubSub.subscribe('reloadsectional', this.onsectional.bind(this));
        this.props.onLoading(true);
        this.getInfoSales(this.state.maxYear, this.props.mes, this.props.sectional);
    }

    onmaxyaer() {
        console.log(this.props.maxYear);
        this.props.onLoading(true);
        this.setState({
            maxYear: this.props.maxYear
        })
        this.props.onLoading(false);
    }
    onmes() {
        console.log(this.props.mes);
        this.props.onLoading(true);
        this.setState({
            mes: this.props.mes
        })
        this.props.onLoading(false);
    }
    onsectional() {
        console.log(this.props.sectional);
        this.props.onLoading(true);
        this.setState({
            sectional: this.props.sectional
        })
        this.props.onLoading(false);
    }

    componentDidUpdate() {
        this.props.onLoading(true);
        if (this.state.maxYear  != this.props.maxYear || this.state.mes != this.props.mes || this.state.sectional != this.props.sectional) {
            this.getInfoSales(this.state.maxYear, this.props.mes, this.props.sectional);
        }
    }

    getInfoSales(anio,mes,sectional) {
        if(anio!= null){
            this.API_URL =  "/ConsultantsByBank/anio/"+anio+"/seccional/"+sectional+"/mes/"+mes
            this.API_URL_SECTIONAL_COUNTRY =  "/CountrySectionalCount/anio/"+anio+"/seccional/"+sectional+"/mes/"+mes
        }

        fetch(this.API_URL)
            .then((res) => res.json())
            .then((data1) => {
                // var structure = []
                // let ejecutivo = ""
                // let Bancolombia = 0;
                // let Bbva = 0;
                // let Davivienda = 0;
                // let Otros = 0;
                // data1.map(item => {
                //     if(ejecutivo != item.ejecutivo){
                //         if(ejecutivo != ""){
                //             let total = Bancolombia + Bbva + Davivienda + Otros
                //             ejecutivo = new EjecutivoBanco(ejecutivo, Bancolombia, Bbva, Davivienda, Otros, total);
                //             structure.push(ejecutivo);
                //             Bancolombia = 0;
                //             Bbva = 0;
                //             Davivienda = 0;
                //             Otros = 0;
                //         }
                //         ejecutivo = item.ejecutivo;
                //     }
                //
                //     switch (item.banco){
                //         case "BANCOLOMBIA":
                //             Bancolombia = item.total;
                //             break;
                //         case "BBVA":
                //             Bbva = item.total;
                //         case "DAVIVIENDA":
                //             Davivienda = item.total;
                //             break;
                //         case "OTROS BANCOS":
                //             Otros = item.total;
                //             break;
                //     }
                //
                // });
                // let total = Bancolombia + Bbva + Davivienda + Otros
                // ejecutivo = new EjecutivoBanco(ejecutivo, Bancolombia, Bbva, Davivienda, Otros, total);
                // structure.push(ejecutivo);
                // console.log(structure)
                // this.setState(() => ({
                //     data: structure
                // }), ()=>{
                //     this.props.onLoading(false);
                // })
                const result = Object.values(data1.reduce((acc, {ejecutivo, banco, total}) => {
                    if (!acc[ejecutivo]) {
                        acc[ejecutivo] = { Ejecutivo: ejecutivo, BancoTotal: {} };
                    }

                    acc[ejecutivo][banco] = acc[ejecutivo][banco] || 0; // provide default value
                    acc[ejecutivo][banco] += total;

                    acc[ejecutivo].BancoTotal[banco] = acc[ejecutivo].BancoTotal[banco] || 0; // provide default value
                    acc[ejecutivo].BancoTotal[banco] += total;

                    acc[ejecutivo].BancoTotal.Total = acc[ejecutivo].BancoTotal.Total || 0; // provide default value
                    acc[ejecutivo].BancoTotal.Total += total;

                    return acc;
                }, {}));
                console.log(result)
                this.setState(() => ({
                    data: result
                }), ()=>{
                    this.props.onLoading(false);
                })
            });


        fetch(this.API_URL_SECTIONAL_COUNTRY)
            .then((res) => res.json())
            .then((data1) => {
                var structure1 = [];
                var i = 0;
                let seccionalValue = 0;
                data1.map(item => {

                    if(i === 0){
                        seccionalValue = item.total;
                        let seccional = new CountrySectionalComparativeModel("Seccional", seccionalValue);
                        structure1.push(seccional);
                    }
                    if(i === 1){
                        let pais = new CountrySectionalComparativeModel("Resto del Pais", item.total - seccionalValue);
                        structure1.push(pais);
                    }
                    i++;
                });
                console.log(structure1)
                this.setState(() => ({
                    dataGlobal : structure1
                }), ()=>{
                    this.props.onLoading(false);
                })
            });

    }
    render() {
        return(
            <Row>
                <Col xs={12} md={8}>
                    <Widget
                        title={<h5><span className="fw-semi-bold">Ejecutivos por Banco</span></h5>}>
                        {this.state.maxYear ?
                            <BarChart data ={this.state.data}
                            /> : null}
                    </Widget>
                </Col>
                <Col xs = {4} md = {4}>
                    <Widget
                        title={<h5><span className="fw-semi-bold">Seccional vs País</span></h5>}>
                        {this.state.maxYear ?
                            <SectionalCountry data = {this.state.dataGlobal}
                            /> : null}
                    </Widget>
                </Col>
            </Row>
        )
    }
}